module.exports = __webpack_public_path__ + "media/images/icon__smallInfoBox-9fc9dbd2495a92bb4c245900973b9434.png";